
export class CultureIdentifiers {
    public id : number;
    public slug : string;
    public iso : string; // 'FJ'
}